var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"osm-map-page"},[_c('div',{staticClass:"map-container"},[_c('OsmMapView',{attrs:{"center":_vm.center,"zoom":_vm.zoom,"myPosition":_vm.myPosition,"showMyPosition":_vm.showMyPosition,"circleRadius":_vm.circleRadius,"inKqArea":_vm.localInKqArea,"showCompanyMarker":true}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }